import React from 'react';
import JotformEmbed from 'react-jotform-embed';

const Complaints = () => {
  return (
    <div>
        <div className="align-items-center mt-5">
            <br/>
            <h1 className="text-center">
                <strong style={{color:'#1e44c1'}}>
                    biteship
                </strong>
            </h1>
        </div>
        <JotformEmbed src="https://form.jotform.com/202820715928053" />
    </div>
  );
};

export default Complaints;
